import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { csv } from 'd3-fetch'
import { useChartDimensions } from '../../hooks/dimensions'
import { Flex } from '../atoms/Basics'
import ChartTitle from '../atoms/ChartTitle'
import ChartContainer from '../atoms/ChartContainer'
import SvgWrapper from '../molecules/SvgWrapper'
import Sankey from '../molecules/Sankey'
import Note from '../atoms/Note'

const SankeyContainer = styled.div`
  width: 100%;
  height: 625px;
  margin: 2rem 0;
`
const LegendCircle = styled.div`
  background-color: ${(props) => props.theme.colors.blue};
  border-radius: 50%;
  width: 1.75rem;
  min-width: 1.75rem;
  height: 1.75rem;
  margin-right: 0.5rem;
`
const PerfVsPot = ({ note }) => {
  const $ = window.WILDLABS_VARS
  const [preppedData, setPreppedData] = useState()
  const [ref, dimensions] = useChartDimensions()

  useEffect(() => {
    csv('./data/perfVsPot.csv').then((data) => {
      const prepData = (data) => {
        const dataSorted = data.sort((a, b) =>
          +a.current_overall_performance_ranking <
          +b.current_overall_performance_ranking
            ? -1
            : 1
        )

        const links = dataSorted?.map((l) => ({
          source: l.group,
          target: 'tg' + l.group,
          value: 1,
          leftRank: +l.current_overall_performance_ranking,
          rightRank: +l.capacity_to_advance_ranking
        }))
        const nodes = [
          ...new Set(
            links
              ? links
                  .map((l) => [
                    {
                      name: l.source,
                      category: l.source,
                      leftRank: l.leftRank,
                      rightRank: 0
                    },
                    {
                      name: l.source,
                      category: l.target,
                      leftRank: 0,
                      rightRank: l.rightRank
                    }
                  ])
                  .flat()
              : null
          )
        ]

        //chaining the sort operations doesn't work properly in Firefox (works in Chrome and Safari)
        // nodes
        //   .sort((a, b) => (a.rightRank < b.rightRank ? -1 : 1))
        //   .sort((a, b) => (a.leftRank < b.leftRank ? -1 : 1))
        // return { n: nodes, l: links }

        //to handle difference in how Firefox and Chrome handle sort
        const leftNodes = nodes.filter((node) => node.leftRank)
        const rightNodes = nodes.filter((node) => node.rightRank)

        leftNodes.sort((a, b) => (a.leftRank < b.leftRank ? -1 : 1))
        rightNodes.sort((a, b) => (a.rightRank < b.rightRank ? -1 : 1))

        const sortedNodes = rightNodes.concat(leftNodes)
        return { n: sortedNodes, l: links }
      }
      setPreppedData(prepData(data))
    })
  }, [])

  return (
    <ChartContainer>
      <ChartTitle text={$.perf_titles.chartTitle} />
      <Flex>
        <LegendCircle />
        <p>{$.perf_titles.legendText}</p>
      </Flex>
      <SankeyContainer ref={ref}>
        <SvgWrapper dimensions={dimensions}>
          <Sankey data={preppedData} />
        </SvgWrapper>
        <Note note={note} type={'sankey'} />
      </SankeyContainer>
    </ChartContainer>
  )
}

export default PerfVsPot
